<template>
    <div>
            <b-card no-body>
                <b-tabs card>
                  <b-tab lazy title="Escalation Contact" active>
                    <b-card>
                      <b-row><b-col align="center"><p class='small'>This shows the current escalation contact for this location. This is the person who is responsible for any escalated alerts and notifications generated from the devices and the Risk Control Measures detailed for the location.</p></b-col></b-row>
                      <b-row><b-col align="right"><b>Escalation Name</b></b-col><b-col>{{ this.EscalationContact.EscalationName }}</b-col></b-row>
                      <b-row><b-col align="right"><b>Escalation Email</b></b-col><b-col>{{ this.EscalationContact.EscalationEmail }}</b-col></b-row>
                      <b-row><b-col align="right"><b>Escalation Tel</b></b-col><b-col>{{ this.EscalationContact.EscalationTel }}</b-col></b-row>
                      <b-row><b-col align="right"><b>Escalation Seraph User</b></b-col><b-col>{{ this.EscalationContact.EscalationSeraph }}</b-col></b-row>
                      <hr/>
                      <b-row><b-col align="center"><BIconPencil v-b-popover.hover.top="'Edit Escalation Details'" v-on:click="editEscalation()" variant="info" font-scale="1.5" /></b-col></b-row>
                    </b-card>
                  </b-tab>
        </b-tabs>
                </b-card>
        <b-modal 
            header-bg-variant="light"
            header-text-variant="dark"
            ref="EscalationEditor"
            id="EscalationEditor"
            title="Escalation Contact Details"
            hide-footer>
            <b-card>
                <b-row><b-col><b>Escalation Name</b></b-col><b-col><b-form-input v-model="EditContact.EscalationName"></b-form-input></b-col></b-row>
                <b-row><b-col><b>Escalation Email</b></b-col><b-col><b-form-input v-model="EditContact.EscalationEmail"></b-form-input></b-col></b-row>
                <b-row><b-col><b>Escalation Tel</b></b-col><b-col><b-form-input v-model="EditContact.EscalationTel"></b-form-input></b-col></b-row>
                <b-row><b-col><b>Escalation Seraph User</b></b-col><b-col><b-form-select v-model="EditContact.EscalationSeraph" :options="options"></b-form-select></b-col></b-row>
                <hr/>
                <b-row><b-col align="right"><b-button size="sm" variant="outline-info" v-on:click="UpdateEscalation()">Submit</b-button></b-col>
                    <b-col align="left"><b-button size="sm" variant="outline-danger" v-on:click="cancelModal()">Cancel</b-button></b-col></b-row>
            </b-card>
        </b-modal>
                </div>
</template>

<script>
import axios from "axios";
import {} from "bootstrap-vue";
import {
  BIconPencil
} from "bootstrap-vue";


export default {
  computed: {},
  components: {
    BIconPencil

  },

  data() {
    return {
      selectedlocation: localStorage.getItem("CurrentLocation"),
      CurrentUser: localStorage.getItem("fullname"),
      EscalationContact: {
        EscalationName: "",
        EscalationEmail: "",
        EscalationTel: "",
        EscalationSeraph: ""
      },
      EditContact: {
        EscalationName: "",
        EscalationEmail: "",
        EscalationTel: "",
        EscalationSeraph: ""
      },
      ValidMail: false,
      options: [{ value: null, text: 'Please select an option' },
                            { value: 'true', text: 'True' },
                            { value: 'false', text: 'False' }],
       
    };

    
},

  beforeMount() {

  },

  mounted() {

    let submitURL = "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
                this.$environment +
                "/controlscheme";
                let submitHeaders = this.$apikeyPost;
                let submitRequest = {
                            RequestType: "RetrieveEscalation",
                            DataDict: [{
                            Location: this.selectedlocation,
                            }]
                            }

                axios.post(submitURL, submitRequest, submitHeaders).then((response) => {
                  if(response.data.Values == ""){
                    this.EscalationContact.EscalationName = ""
                    this.EscalationContact.EscalationEmail = ""
                    this.EscalationContact.EscalationTel = ""
                    this.EscalationContact.EscalationSeraph = ""
                  } else{
                    this.EscalationContact.EscalationName = response.data.Values[0][0]
                    this.EscalationContact.EscalationEmail = response.data.Values[0][1]
                    this.EscalationContact.EscalationTel = response.data.Values[0][2]
                    this.EscalationContact.EscalationSeraph = response.data.Values[0][3]
                  }
                        });


  },

  methods: {

    editEscalation(){
      this.EditContact = this.EscalationContact
      this.$refs["EscalationEditor"].show()
    },
    UpdateEscalation(){
      if(this.EditContact.EscalationName == "" || this.EditContact.EscalationEmail == "" || this.EditContact.EscalationTel == "" ||this.EditContact.EscalationSeraph == null){
            alert('All fields on this page must be completed prior to moving on')
        }
        else if(this.emailIsValid(this.EditContact.EscalationEmail) == false){
            alert("Please check email address format")}
      else{
        let submitURL = "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
                this.$environment +
                "/controlscheme";
                let submitHeaders = this.$apikeyPost;
                let submitRequest = {
                            RequestType: "EditEscalation",
                            DataDict: [{
                            Location: this.selectedlocation,
                            EscalationContact: {
                                EscalationName: this.EditContact.EscalationName,
                                EscalationEmail: this.EditContact.EscalationEmail,
                                EscalationTel: this.EditContact.EscalationTel,
                                EscalationSeraph: this.EditContact.EscalationSeraph,
                                Status: "Active"}
                            }]
                            }

                axios.post(submitURL, submitRequest, submitHeaders).then((response) => {
                response;
                this.updateVirtualLog()
                this.$refs['EscalationEditor'].hide()
                this.EditContact = 
                    { EscalationName: "",
                      EscalationEmail: "",
                      EscalationTel: "",
                      EscalationSeraph: ""
                    }
                this.refreshData()
                        });
      }

    },
    cancelModal(){
      this.EditContact = 
      { EscalationName: "",
        EscalationEmail: "",
        EscalationTel: "",
        EscalationSeraph: ""
      }
      this.$refs['EscalationEditor'].hide()
    },
    emailIsValid(email) {
        this.ValidMail = /\S+@\S+\.\S+/.test(email);
        return this.ValidMail
      },
      refreshData(){
        let submitURL = "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
                this.$environment +
                "/controlscheme";
                let submitHeaders = this.$apikeyPost;
                let submitRequest = {
                            RequestType: "RetrieveEscalation",
                            DataDict: [{
                            Location: this.selectedlocation,
                            }]
                            }

                axios.post(submitURL, submitRequest, submitHeaders).then((response) => {
                  if(response.data.Values == ""){
                    this.EscalationContact.EscalationName = ""
                    this.EscalationContact.EscalationEmail = ""
                    this.EscalationContact.EscalationTel = ""
                    this.EscalationContact.EscalationSeraph = ""
                  } else{
                    this.EscalationContact.EscalationName = response.data.Values[0][0]
                    this.EscalationContact.EscalationEmail = response.data.Values[0][1]
                    this.EscalationContact.EscalationTel = response.data.Values[0][2]
                    this.EscalationContact.EscalationSeraph = response.data.Values[0][3]
                  }
                        });
      
      },
      updateVirtualLog(){
        let current = new Date();
        this.today = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
        let timestamp = new Date().toLocaleTimeString()
            let SubmitUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/notes";
      let SubmitHeaders = this.$apikeyPost;
      let SubmitLookUpRequest = {
        RequestType: "CreateVirtualLog",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID:"",
            Location: this.selectedlocation ,
            NoteDate: this.today ,
            NoteTime: timestamp,
            NoteTrigger: 'Escalation Contact Update' ,
            NoteTitle: "Escalation Contact Updated",
            NoteText: "The Escalation Details for the location have been updated",
            UserName: this.CurrentUser
          }]
        };
      axios
        .post(SubmitUrl, SubmitLookUpRequest, SubmitHeaders)
        .then((response) => {
          response;

        });
      }

  }
}
</script>

<style>


</style>
